import React, { useState } from "react";
import {useLocation, useNavigate} from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import { addInternationalBrand } from "../../actions/International";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface FormData {
    name: string;
    content: string;
    bw_logo: File | null;
    color_logo: File | null;
    cover_image: File | null;
    instagram_url: string | null;
    facebook_url: string | null;
    twitter_url: string | null;
    website_url: string | null;
}

function AddInternationalBrand() {

    const [formData, setFormData] = useState<FormData>({
        name: "",
        content: "",
        bw_logo: null,
        color_logo: null,
        cover_image: null,
        instagram_url: "",
        facebook_url: "",
        twitter_url: "",
        website_url: "",
    });

    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);

    const [imagePreview, setImagePreview] = useState<{
        bw_logo?: string | null;
        color_logo?: string | null;
        cover_image?: string | null;
    }>({});

    const ReactQuill = require('react-quill');
    const quillModules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["link", "image"],
            ["clean"],
        ],
    };

    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, type } = e.target;

        if (type === "file") {
            const file = (e.target as HTMLInputElement).files?.[0] || null;
            setFormData(prev => ({ ...prev, [name]: file }));

            if (file) {
                setImagePreview(prev => ({ ...prev, [name]: URL.createObjectURL(file) }));
            } else {
                setImagePreview(prev => ({ ...prev, [name]: null }));
            }

        } else {
            setFormData(prev => ({ ...prev, [name]: (e.target as HTMLInputElement).value }));
        }
    };
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        try {
            const payload = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                payload.append(key, value instanceof File ? value : value ?? "");
            });

            const response = await addInternationalBrand(payload);

            if (response.status === 201) {
                alert("Brand Successfully Added!");
                navigate("/dashboard/international/brands/list", { state: { user } });
                // optional resets
                // window.location.reload();
            }

        } catch (error) {
            console.error("Submit Error:", error);
            alert("Something went wrong submitting the form");
        }
    };

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user}/>
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user}/>

            <div className={`main-admin-page ${isCollapsed ? "collapsed" : "expanded"}`}>
                <h2>Add International Brand</h2>

                <form onSubmit={handleSubmit} encType="multipart/form-data"
                      style={{ display:"flex", flexDirection:"column", gap:"15px" }}>

                    {/* NAME */}
                    <input
                        type="text"
                        className="input-email"
                        placeholder="Brand Name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                    />

                    {/* CONTENT - REACT QUILL WYSIWYG */}
                    <label>Brand Content</label>
                    <ReactQuill
                        theme="snow"
                        value={formData.content}
                        onChange={(value: any) => setFormData(prev => ({ ...prev, content:value }))}
                        modules={quillModules}
                        style={{ background:"#fff", minHeight:"200px", marginBottom:"20px" }}
                    />

                    {/* LOGOS SIDE BY SIDE */}
                    <div style={{ display:"flex", gap:"15px" }}>
                        <div style={{ flex:1, textAlign:"left", display: "flex", flexDirection: "column" }}>
                            <label>Black & White Logo</label>
                            <input type="file" name="bw_logo" accept="image/*" onChange={handleInputChange}/>
                            {imagePreview.bw_logo && <img src={imagePreview.bw_logo} style={{ width:"100%", maxWidth:"180px", marginTop:"10px"}}/>}
                        </div>

                        <div style={{ flex:1, textAlign:"left", display: "flex", flexDirection: "column" }}>
                            <label>Color Logo</label>
                            <input type="file" name="color_logo" accept="image/*" onChange={handleInputChange}/>
                            {imagePreview.color_logo && <img src={imagePreview.color_logo} style={{ width:"100%", maxWidth:"180px", marginTop:"10px"}}/>}
                        </div>
                    </div>

                    {/* COVER IMAGE */}
                    <div style={{ flex:1, textAlign:"left", display: "flex", flexDirection: "column" }}>
                        <label>Cover Image</label>
                        <input type="file" name="cover_image" accept="image/*" onChange={handleInputChange}/>
                        {imagePreview.cover_image && <img src={imagePreview.cover_image} style={{ width:"100%", maxWidth:"450px", marginTop:"10px"}}/>}
                    </div>

                    {/* SOCIAL LINKS */}
                    <input type="text" name="instagram_url" placeholder="Instagram URL" className="input-email" onChange={handleInputChange}/>
                    <input type="text" name="facebook_url" placeholder="Facebook URL" className="input-email" onChange={handleInputChange}/>
                    <input type="text" name="twitter_url" placeholder="Twitter URL" className="input-email" onChange={handleInputChange}/>
                    <input type="text" name="website_url" placeholder="Website URL" className="input-email" onChange={handleInputChange}/>

                    <button type="submit" className="btn btn-success" style={{ marginTop:"10px" }}>
                        Submit
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddInternationalBrand;
